import React from 'react'
import * as constants from '../constants'
import { COLUMN_TYPES, COLUMN_SORT_SETTING } from '../components/dataTable'
import { Icon } from '@adc/ui-core'
import * as dataTable from './dataTable'
import { LOOKUP_TYPES } from '../components/dataTable/searchField'

const {
  actionCellActionTypes: { ACTION_CELL_ACTION_TYPES },
} = constants

const defaultColProps = {
  width: 200,
  isResizable: true,
  isReorderable: true,
  isVisible: true,
  searchable: false,
  sort: COLUMN_SORT_SETTING.NOT_SORTABLE,
}

export const auditTableConfig = tableName => ({
  config: {
    entityKey: tableName,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Updated By',
      apiRef: 'updated_by',
      foreignKey: LOOKUP_TYPES.USER,
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'Updated On',
      apiRef: 'updated_date',
      columnDefinition: {
        type: COLUMN_TYPES.DATE,
        colProps: defaultColProps,
      },
    },
    {
      name: 'Name',
      apiRef: 'name',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'Field',
      apiRef: 'field',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'From',
      apiRef: 'from',
      formatOptions: {
        custom: 'auditHistoryFormatter',
      },
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'To',
      apiRef: 'to',
      formatOptions: {
        custom: 'auditHistoryFormatter',
      },
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: '',
      apiRef: '__actions__', // not api val
      isUiOnly: true,
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: [ACTION_CELL_ACTION_TYPES.DISPLAY_DETAILS],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
  sortBy: [
    {
      field: '',
      order: '',
    },
  ],
})

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='zoom'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() =>
          onRowAction(actionCellActionType, rowIndex, primaryId, data)
        }
      />
    )

export const auditColumnSelector = (
  state,
  enableNameColumn = false,
  nameColumnTitle = 'Name'
) => {
  return state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .filter(field => (!enableNameColumn ? field.apiRef !== 'name' : field))
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }

      if (enableNameColumn && column.field === 'name') {
        column.title = nameColumnTitle
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      if (col.dataType) column.dataType = col.dataType
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      return column
    })
}
export const getAuditFilterClauses = state => state.filterClauses

export default tableType =>
  dataTable.dataTable(tableType, auditTableConfig(tableType))
